/**
 * useViewMode — Sayfaya özel liste/kart görünümü tercihini localStorage'ta
 * kalıcı olarak saklar. Kullanım:
 *
 *   const [view, setView] = useViewMode("customers", "list");
 *
 * Anahtar önekli olarak `fucan_view_<key>` şeklinde saklanır.
 */
import { useCallback, useState } from "react";

export default function useViewMode(key, defaultValue = "list") {
  const storageKey = `fucan_view_${key}`;
  const [view, setViewState] = useState(() => {
    try {
      return localStorage.getItem(storageKey) || defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const setView = useCallback((v) => {
    setViewState(v);
    try { localStorage.setItem(storageKey, v); } catch { /* ignore */ }
  }, [storageKey]);

  return [view, setView];
}
